import { formatInTimeZone } from 'date-fns-tz';

const TZ = 'Europe/London';

export function formatGbp(amount: number): string {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount);
}

export function formatPct(value: number): string {
  return `${Math.round(value * 100)}%`;
}

export function formatDate(date: Date | string): string {
  return formatInTimeZone(new Date(date), TZ, 'dd MMM yyyy');
}

export function formatDateTime(date: Date | string): string {
  return formatInTimeZone(new Date(date), TZ, "dd MMM yyyy 'at' HH:mm");
}

export function formatCpl(cpl: number): string {
  return `£${cpl.toFixed(2)}`;
}
